const variables = {
  logo: 'Negative',
};

export default variables;
